import {twMerge} from "tailwind-merge";

const Skeleton = ({className}) => {
    return <div className={twMerge("skeleton rounded", className)}/>;
};

export default Skeleton;
